// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__UF5-w","containerItemsCenter":"Skeleton_containerItemsCenter__DW-ub"};